import "./arrowed_gallery.css";
import { gsap } from "gsap";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    let current = 0;

    const gallery = document.getElementById("arrowed_gallery");
    const items = document.querySelectorAll(".arrowed_gallery_item");
    const left = document.getElementById("arrowed_gallery_navigation_left");
    const right = document.getElementById("arrowed_gallery_navigation_right");
    let tween;
    const pointer = document.getElementById(
      "arrowed_gallery_navigation_current",
    );

    if (!gallery) return;

    const shift =
      window.innerWidth >= 992 ? gallery.clientWidth : items[0].clientWidth + 7;

    const update = () => {
      if (tween) tween.kill();
      tween = gsap.to(gallery, {
        scrollTo: {
          x: current * shift,
          autoKill: false,
        },
        duration: 2,
        ease: "power3.out",
        onStart: () => {
          if (window.innerWidth >= 992) {
            pointer.innerHTML = current + 1;
          }
        },
        onComplete: () => {
          gallery.style.removeProperty("scroll-snap-type");
        },
      });
    };

    left.addEventListener("click", () => {
      current = (items.length + current - 1) % items.length;
      update();
    });

    right.addEventListener("click", () => {
      current = (current + 1) % items.length;
      update();
    });

    gallery.addEventListener("scroll", () => {
      if (window.innerWidth < 992) {
        current = Math.round(gallery.scrollLeft / shift);
        pointer.innerHTML = current + 1;
      }
    });
  },
  false,
);
